module.exports = "/_next/static/images/PhilipBayne-941c100be09d1ba3126146deda100820.webp";